/**
 * Google Analytics utility functions
 * Using Measurement ID: G-QGWLREXT9J
 */

// Initialize gtag safely
const gtag = (...args) => {
  if (window.gtag) {
    window.gtag(...args);
  } else {
    console.warn('Google Analytics (gtag.js) not loaded yet.');
  }
};

/**
 * Track a page view
 * @param {string} path - The page path (e.g., /dashboard)
 * @param {string} title - The page title
 */
export const trackPageView = (path, title) => {
  gtag('config', 'G-QGWLREXT9J', {
    page_path: path,
    page_title: title,
  });
};

/**
 * Track a custom event
 * @param {string} action - The event action (e.g., 'click', 'submit')
 * @param {string} category - The event category (e.g., 'Navigation', 'Feature')
 * @param {string} label - The event label (optional)
 * @param {number} value - The event value (optional)
 */
export const trackEvent = (action, category, label = '', value = 0) => {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

/**
 * Specific helper for feature clicks
 * @param {string} featureName - The name of the feature being clicked
 */
export const trackFeatureClick = (featureName) => {
  trackEvent('feature_click', 'Engagement', featureName);
};

/**
 * Specific helper for button clicks
 * @param {string} buttonName - The name of the button
 * @param {string} location - Where the button is located (e.g., 'Dashboard', 'Login')
 */
export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', 'Interaction', `${location} - ${buttonName}`);
};

/**
 * Track user login
 * @param {string} method - The login method (e.g., 'email', 'google')
 */
export const trackLogin = (method) => {
  gtag('event', 'login', {
    method: method,
  });
};
